export enum PlayerPageFilters {
    Stats = 'stats',
    Transfers = 'transfers',
}